import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@mui/material'
import { formatPhoneNumber, justNumbers, validatePhone } from '../utils/PhoneNumber';
import FeedbackContext from '../context/FeedbackContext';

const EditPhoneModal = ({ toggleModal, updatePhone }) => {
  const [ newPhone, setNewPhone ] = useState('')
  const [ hasError, setHasError ] = useState(false)
  const [ errorMessage, setErrorMessage ] = useState('')
  const { isLoading, setIsLoading } = useContext(FeedbackContext);

  const handleUpdate = async (event) => {
    setIsLoading(true);
    event.preventDefault()
    const validPhone = validatePhone(newPhone)
    if (validPhone){
      const result = await updatePhone(validPhone);
      if(result instanceof Error) {
        setErrorMessage(result.message);
        setHasError(true)
      } else {
        setHasError(false)
      }
    } else {
      setErrorMessage('Invalid phone number')
      setHasError(true)
      setIsLoading(false)
    }
  }

  const handleChange = (event) => {
    setNewPhone(justNumbers(event.target.value));
  };

  return (
    <div className='fixed z-10 inset-0 overflow-y-auto '>
      <div className='absolute w-full h-full bg-gray opacity-50'></div>
      <div className='flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
        <div className='fixed inset-0 transition-opacity' aria-hidden='true'>
          <div className='absolute inset-0 bg-gray-500 opacity-75'></div>
        </div>

        <span className='hidden sm:inline-block sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>

        <div
          className='inline-block align-bottom bg-gray-lighter50 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'
          role='dialog'
          aria-modal='true'
          aria-labelledby='modal-headline'
        >
          <div className='bg-gray-50 px-4 pt-5 pb-6 sm:p-6 sm:pb-6'>
            <h3
              className='text-xxl leading-6 font-bold text-gray-900 text-center'
              id='modal-headline'
            >
              New Phone Number
            </h3>
          </div>
          <form onSubmit={handleUpdate}>
            <div className='flex justify-center bg-gray-50'>
              <TextField 
                error={hasError}
                onChange={handleChange} 
                value={formatPhoneNumber(newPhone)}
                type='text'
                variant="outlined"
                label='Please Enter Phone' 
                className='my-6'
                placeholder='(xxx) xxx-xxxx'
                inputProps={{
                  maxLength: 10
                }}
              />
            </div>
            <div className='flex justify-center bg-gray-50'>
              {hasError && <p className='text-center text-red'>{errorMessage}</p>}
            </div>
            <div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row justify-around'>
              <button
                type='submit'
                disabled={isLoading}
                className='w-full w-1/2 inline-flex justify-center rounded-md border-radius-2 border border-transparent shadow-sm px-4 py-2 bg-green text-base font-lg text-white hover:bg-green-bright focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 text-lg font-bold'
              >
                Update
              </button>
              <button
                type='button'
                disabled={isLoading}
                className='mt-3 w-full w-1/2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red text-base font-lg text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 text-lg font-bold'
                onClick={() => {
                  toggleModal();
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

EditPhoneModal.propTypes = {
  toggleModal: PropTypes.func,
  updatePhone: PropTypes.func
}

export default EditPhoneModal
